import { store } from '@reduxStore';
import { JobCategory } from '../JobCategories/types';
import { Vessel, Voyage } from '../Vessels/types';
import { Location } from '../Location/types';
import { jobSlice } from './slice';

/** GET Job Response */
export interface Job {
  id: number;
  cat: string;
  bookingRefNo?: string;
  masterBol?: string;
  vslId?: string;
  voyageId?: number;
}

/**
 * Fields that can be altered and returned to the Job PATCH API.
 * Omitting the id because that will not count towards being a 'change' when evaluating mutations.
 */
export type MutableJob = Partial<Omit<Job, 'id' | 'cat' | 'vslId' | 'voyageId'>> & {
  /** Need to accept the full type to properly update the cache */
  category?: JobCategory;
  vessel?: Vessel | null;
  voyage?: Voyage | null;
  allowDupMasterBol?: boolean;
  allowDupBookingRefNo?: boolean;
};

/** PATCH API requires the Job ID and at least an altered field */
export type PatchJobRequest = Pick<Job, 'id'> &
  MutableJob & {
    /** For current simplicity, just provide the consignment ID to update the cache. */
    consignmentId?: number;
    /** Provided LegIds to update Dispatch with the changes to the Job */
    legIds?: number[];
  };

/** PUT updateLocations: applies each location's saved name and address to the legs on the job that use it */
export interface UpdateJobLocationsRequest {
  terminalNumber: string;
  jobId: number;
  locations: Location[];
}

export async function isBillOfLadingNumberValidAsync(billOfLadingNo?: string | null): Promise<string | null> {
  const terminalNumber = store.getState().applicationState.selectedTerminal?.number || '';

  let isValid = null;
  if (billOfLadingNo) {
    try {
      const response = await store
        .dispatch(
          jobSlice.endpoints.validateBillofLadingNo.initiate(
            {
              terminalNumber: terminalNumber,
              masterBol: billOfLadingNo
            },
            { forceRefetch: true }
          )
        )
        .unwrap();
      isValid = response.message;
    } catch (ex: unknown) {
      // Just post a toast we couldn't validate it?
      console.log(ex);
    }
  }
  return isValid;
}

export async function isBookingRefNumberValidAsync(bookingRefNo?: string | null): Promise<string | null> {
  const terminalNumber = store.getState().applicationState.selectedTerminal?.number || '';

  let isValid = null;
  if (bookingRefNo) {
    try {
      const response = await store
        .dispatch(
          jobSlice.endpoints.validateBookingRefNo.initiate(
            {
              terminalNumber: terminalNumber,
              bookingRefNo: bookingRefNo
            },
            { forceRefetch: true }
          )
        )
        .unwrap();
      isValid = response.message;
    } catch (ex: unknown) {
      // Just post a toast we couldn't validate it?
      console.log(ex);
    }
  }
  return isValid;
}
